export const mapSearches = (searches = []) =>
  searches?.length
    ? searches.map((search) => ({ id: search, name: search }))
    : [];
